export default __webpack_public_path__ + "static/media/cart.b2751654.png";